<template>
    <b-container fluid class="pl-5 pr-5">
        <div class='impressum text-light bg-dark'><h1>Impressum</h1>
            <p>Angaben gemäß § 5 TMG</p>
            <p>Munich Falcons GmbH<br>
            Habichtstr. 10<br>
                85662 Hohenbrunn <br>
        </p><p> <strong>Vertreten durch: </strong><br>
                Carl-Heinz Natterer<br>
        </p><p><strong>Kontakt:</strong> <br>
            Telefon: +49 172 8166713<br>
            E-Mail: <a href='mailto:info@falcons.digital'>info@falcons.digital</a><br></p><p><strong>Umsatzsteuer-ID: </strong> <br>
            Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz: DE290040206<br><br>
        </p><p><strong>Registergericht:</strong><br>
                Eintragung im Handelsregister<br>
                Registernummer: HRB 205766<br>
                Amtsgericht München
            </p>
            <p>
                Inhaltlich Verantwortlicher: Carl-Heinz Natterer (Anschrift s.o.)
            </p>
            <p>
                <strong>Haftungsausschluss</strong><br>
                Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
            </p>
            <p>
                <strong>Urheberrecht</strong><br>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.<br><br>
            </p>
                <div id="datenschutz"><strong>Datenschutz</strong></div><br>
                Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder eMail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben. <br>
                Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich. <br>
                Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.<br>
                <br>
                <strong>Arten der verarbeiteten Daten:</strong><br>
                <ul>
                    <li>Inhaltsdaten (z.B., Texteingaben, Fotografien, Videos).</li>
                    <li>Nutzungsdaten (z.B., besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten).</li>
                    <li>Meta-/Kommunikationsdaten (z.B., Geräte-Informationen, IP-Adressen).</li>
                </ul>

                <br><strong>Youtube</strong><br>
                Wir binden die Videos der Plattform “YouTube” des Anbieters Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA, ein. Datenschutzerklärung: <a href="https://www.google.com/policies/privacy/" target="_blank">https://www.google.com/policies/privacy/</a>, Opt-Out: <a href="https://adssettings.google.com/authenticated" target="_blank">https://adssettings.google.com/authenticated</a>.

        </div>
        <br><br>
    </b-container>

</template>

<script>
    export default {
        name: "Impressum"
    }
</script>

<style scoped>

</style>